var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 667.09 619.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 8100") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CORP_D",
    "data-name": "CORP D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.09,536v-8.65q0-248.92,0-497.87a58.5,58.5,0,0,1,.35-9.65,23.79,23.79,0,0,1,47.2,2.53c.19,2.72.08,5.46.08,8.19V535.91c3.12.63,4-1.95,5.41-3.33,16.09-15.83,32.06-31.79,48.12-47.66,11.06-10.93,24.77-11.28,34.83-1,9.78,10,9.31,23.57-1.4,34.3q-46.25,46.38-92.62,92.61c-11.67,11.62-24.79,11.48-36.54-.24Q483.71,564.83,438,519c-11.09-11.1-12-25-2.28-35,9.83-10.2,24.31-9.7,35.56,1.68,16.91,17.1,33.57,34.45,50.34,51.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.14.07q94.17,0,188.33,0c17.88,0,29.65,15.69,23.87,31.61-3.45,9.52-10.54,14.73-20.55,15.89a57.55,57.55,0,0,1-6.7.11q-185.71,0-371.43,0A48.27,48.27,0,0,1,19,47.16a23.9,23.9,0,0,1-19-25,23.54,23.54,0,0,1,23-22C42-.14,60.82.07,79.67.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.16,190.65c46.89,0,93.79-.07,140.68,0,17.88,0,29.64,15.7,23.85,31.62-3.46,9.52-10.55,14.72-20.56,15.89a59.81,59.81,0,0,1-6.7.1q-138.06,0-276.14,0A45,45,0,0,1,66,237.53,23.81,23.81,0,0,1,47.75,212c1.26-12.28,11.34-21.27,24.5-21.31,35-.12,70,0,105,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.56,381.23q46.14,0,92.29,0c15.78,0,26.62,9.75,26.63,23.79s-10.82,23.82-26.6,23.83q-92.65,0-185.33,0c-15.59,0-26.44-10.11-26.24-24.19.2-13.8,10.86-23.4,26.21-23.43Q168,381.17,214.56,381.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.65,619.45c-14.88,0-29.77,0-44.65,0-15.19-.07-25.95-9.89-26-23.64s10.56-23.94,25.65-24q45.76-.11,91.54,0c15,0,25.79,10.18,25.68,24s-10.83,23.57-26,23.64C244.41,619.5,229,619.45,213.65,619.45Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.29ce6708.svg";
export { ForwardRef as ReactComponent };